import { createSlice } from "@reduxjs/toolkit";
import { ProfileStateProps } from "../interfaces/profile";

const initialState: ProfileStateProps = {
    myPublications: {
        fetching: "unknown",
        data: [],
        total: 0,
        filters: {
            fetching: "unknown",
            data: [],
            text: "",
            states: [],
            branches: [],
            years: [],
            sellers: []
        }
    },
    fetchingMyBuys: "unknown",
    myBuys: null,
    fetchingReport: "unknown",
    report: undefined,
    totalBuys: 0,
    myBuy: {
        fetching: "unknown",
        data: [],
        error: ""
    },
    favorites: {
        fetching: "unknown",
        data: [],
        total: 0,
        likedFetching: "unknown"
    },
    regions: {
        fetching: "unknown",
        data: [],
    },
    cities: {
        fetching: "unknown",
        data: [],
    },
    communes: {
        fetching: "unknown",
        data: [],
    },
    publication: null,
    creditData: null,
    fetchingCreditData: "unknown",
    payments: [],
    fetchingPayments: "unknown",
    fetchingPostDocument: "unknown",
    payment: {
        fetching: "unknown",
        data: [],
        error: null
    },
    paymentDocument: null,
    schedules: {
        fetching: "unknown",
        data: []
    },
    transfer: {
        concessionaries: {
            fetching: "unknown",
            data: []
        },
        branches: {
            fetching: "unknown",
            data: []
        },
        sellers: {
            fetching: "unknown",
            data: []
        },
        fetching: "unknown",
        data: [],
        error: null
    },
    sellers: {
        fetching: "unknown",
        data: [],
        error: "",
        add: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        edit: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        delete: {
            fetching: "unknown",
            data: [],
            error: ""
        }
    },
    branches: {
        fetching: "unknown",
        data: [],
        error: "",
        add: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        edit: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        delete: {
            fetching: "unknown",
            data: [],
            error: ""
        }
    },
    dealerships: {
        list: {
            fetching: "unknown",
            data: [],
            total: 0,
            error: ""
        },
        add: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        edit: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        delete: {
            fetching: "unknown",
            data: [],
            error: ""
        }
    },
    status: {
        fetching: "unknown",
        data: []
    },
    dashboard: {
        branch: "",
        date: {
            start: "",
            end: ""
        },
        salesPeriod: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        salesAcumulated: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        publicationsAndSales: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        status: {
            publications: {
                fetching: "unknown",
                data: [],
                error: ""
            },
            transactions: {
                fetching: "unknown",
                data: [],
                error: ""
            }
        },
        statusChanges: {
            publications: {
                fetching: "unknown",
                data: [],
                error: ""
            },
            transactions: {
                fetching: "unknown",
                data: [],
                error: ""
            }
        },
    },
    branch: {
        fetching: "unknown",
        data: [],
        error: ""
    },
    myOffers: {
        fetching: "unknown",
        data: [],
        error: ""
    }
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        getMyPublicationsRequest: (state) => {
            state.myPublications.fetching = "loading";
        },
        getMyPublicationsSuccess: (state, action) => {
            state.myPublications.fetching = "success";
            state.myPublications.data = action.payload.publications;
            state.myPublications.total = action.payload.total ? action.payload.total : state.myPublications.total;
        },
        getMyPublicationsFailure: (state) => {
            state.myPublications.fetching = "failure";
        },
        cleanMyPublications: (state) => {
            state.myPublications.fetching = initialState.myPublications.fetching;
            state.myPublications.data = initialState.myPublications.data;
        },
        getFilterMyPublicationsRequest: (state) => {
            state.myPublications.filters.fetching = "loading";
        },
        getFilterMyPublicationsSuccess: (state, action) => {
            state.myPublications.filters.fetching = "success";
            state.myPublications.filters.data = action.payload.publications;
        },
        getFilterMyPublicationsFailure: (state) => {
            state.myPublications.filters.fetching = "failure";
        },
        cleanFilterMyPublications: (state) => {
            state.myPublications.filters.fetching = initialState.myPublications.filters.fetching;
        },
        setSearchMyPublications: (state, action) => {
            state.myPublications.filters.text = action.payload;
        },
        setStatesMyPublications: (state, action) => {
            state.myPublications.filters.states = action.payload;
        },
        setBranchesMyPublications: (state, action) => {
            state.myPublications.filters.branches = action.payload;
        },
        setYearsMyPublications: (state, action) => {
            state.myPublications.filters.years = action.payload;
        },
        setSellersMyPublications: (state, action) => {
            state.myPublications.filters.sellers = action.payload;
        },
        cleanDataFiltersMyPublications: (state) => {
            state.myPublications.filters = initialState.myPublications.filters;
        },
        getMyBuysRequest: (state) => {
            state.fetchingMyBuys = "loading";
        },
        getMyBuysSuccess: (state, action) => {
            state.fetchingMyBuys = "success";
            state.myBuys = action.payload.publications;
            state.totalBuys = action.payload.total;
        },
        getMyBuysFailure: (state) => {
            state.fetchingMyBuys = "failure";
        },
        cleanMyBuys: (state) => {
            state.fetchingMyBuys = initialState.fetchingMyBuys;
        },
        getMyBuyRequest: (state) => {
            state.myBuy.fetching = "loading";
        },
        getMyBuySuccess: (state, action) => {
            state.myBuy.fetching = "success";
            state.myBuy.data = action.payload.buys;
            state.totalBuys = action.payload.total ? action.payload.total : state.totalBuys;
        },
        getMyBuyFailure: (state, action) => {
            state.myBuy.fetching = "failure";
            state.myBuy.error = action.payload;
        },
        cleanMyBuy: (state) => {
            state.myBuy.fetching = initialState.myBuy.fetching;
        },
        getRegionsRequest: (state) => {
            state.regions.fetching = "loading";
        },
        getRegionsSuccess: (state, action) => {
            state.regions.fetching = "success";
            state.regions.data = action.payload;
        },
        getRegionsFailure: (state) => {
            state.regions.fetching = "failure";
        },
        getCitiesRequest: (state) => {
            state.cities.fetching = "loading";
        },
        getCitiesSuccess: (state, action) => {
            state.cities.fetching = "success";
            state.cities.data = action.payload;
        },
        getCitiesFailure: (state) => {
            state.cities.fetching = "failure";
        },
        getCommunesRequest: (state) => {
            state.communes.fetching = "loading";
        },
        getCommunesSuccess: (state, action) => {
            state.communes.fetching = "success";
            state.communes.data = action.payload;
        },
        getCommunesFailure: (state) => {
            state.communes.fetching = "failure";
        },
        getFavoritesRequest: (state) => {
            state.favorites.fetching = "loading";
        },
        getFavoritesSuccess: (state, action) => {
            state.favorites.fetching = "success";
            state.favorites.data = action.payload?.favorites;
            state.favorites.total = action.payload?.total;
        },
        setFavorites: (state, action) => {
            state.favorites.data = action.payload;
        },
        getFavoritesFailure: (state) => {
            state.favorites.fetching = "failure";
        },
        cleanFavorites: (state) => {
            state.favorites.fetching = initialState.favorites.fetching;
        },
        likePublicationRequest: (state) => {
            state.favorites.likedFetching = "loading";
        },
        likePublicationSuccess: (state) => {
            state.favorites.likedFetching = "success";
        },
        likePublicationFailure: (state) => {
            state.favorites.likedFetching = "failure";
        },
        dislikePublicationRequest: (state) => {
            state.favorites.likedFetching = "loading";
        },
        dislikePublicationSuccess: (state) => {
            state.favorites.likedFetching = "success";
        },
        dislikePublicationFailure: (state) => {
            state.favorites.likedFetching = "failure";
        },
        cleanLikePublication: (state) => {
            state.favorites.likedFetching = initialState.favorites.likedFetching;
        },
        setPublication: (state, action) => {
            state.publication = action.payload;
        },
        getCreditDataRequest: (state) => {
            state.fetchingCreditData = "loading";
        },
        getCreditDataSuccess: (state, action) => {
            state.fetchingCreditData = "success";
            state.creditData = action.payload;
        },
        getCreditDataFailure: (state) => {
            state.fetchingCreditData = "failure";
        },
        getPaymentsRequest: (state) => {
            state.fetchingPayments = "loading";
        },
        getPaymentsSuccess: (state, action) => {
            state.fetchingPayments = "success";
            state.payments = action.payload;
        },
        getPaymentsFailure: (state) => {
            state.fetchingPayments = "failure";
        },
        cleanPayments: (state) => {
            state.fetchingPayments = initialState.fetchingPayments;
            state.fetchingCreditData = initialState.fetchingCreditData;
        },
        postPaymentDocumentRequest: (state) => {
            state.fetchingPostDocument = "loading";
        },
        postPaymentDocumentSuccess: (state, action) => {
            state.fetchingPostDocument = "success";
            state.paymentDocument = action.payload;
        },
        postPaymentDocumentFailure: (state) => {
            state.fetchingPostDocument = "failure";
        },
        postPaymentRequest: (state) => {
            state.payment.fetching = "loading";
        },
        postPaymentSuccess: (state, action) => {
            state.payment.fetching = "success";
            state.payment.data = action.payload;
        },
        postPaymentFailure: (state, action) => {
            state.payment.fetching = "failure";
            state.payment.error = action.payload;
        },
        cleanPayment: (state) => {
            state.fetchingPostDocument = initialState.fetchingPostDocument;
            state.payment = initialState.payment;
            state.paymentDocument = initialState.paymentDocument;
        },
        getSchedulesRequest: (state) => {
            state.schedules.fetching = "loading";
        },
        getSchedulesSuccess: (state, action) => {
            state.schedules.fetching = "success";
            state.schedules.data = action.payload;
        },
        getSchedulesFailure: (state) => {
            state.schedules.fetching = "failure";
        },
        cleanSchedules: (state) => {
            state.schedules.fetching = initialState.schedules.fetching;
        },
        putTransferPublicationRequest: (state) => {
            state.transfer.fetching = "loading";
        },
        putTransferPublicationSuccess: (state) => {
            state.transfer.fetching = "success";
        },
        putTransferPublicationFailure: (state, action) => {
            state.transfer.fetching = "failure";
            state.transfer.error = action.payload;
        },
        cleanTransferPublication: (state) => {
            state.transfer.fetching = initialState.transfer.fetching;
        },
        getBranchesTransferRequest: (state) => {
            state.transfer.branches.fetching = "loading";
        },
        getBranchesTransferSuccess: (state, action) => {
            state.transfer.branches.fetching = "success";
            state.transfer.branches.data = action.payload;
        },
        getBranchesTransferFailure: (state) => {
            state.transfer.branches.fetching = "loading";
        },
        cleanBranchesTransfer: (state) => {
            state.transfer.branches = initialState.transfer.branches;
        },
        getBranchesRequest: (state) => {
            state.branches.fetching = "loading";
        },
        getBranchesSuccess: (state, action) => {
            state.branches.fetching = "success";
            state.branches.data = action.payload;
        },
        getBranchesFailure: (state) => {
            state.branches.fetching = "loading";
        },
        cleanBranches: (state) => {
            state.branches.fetching = initialState.branches.fetching;
        },
        addBranchRequest: (state) => {
            state.branches.add.fetching = "loading";
        },
        addBranchSuccess: (state, action) => {
            state.branches.add.fetching = "success";
            state.branches.add.data = action.payload;
        },
        addBranchFailure: (state, action) => {
            state.branches.add.fetching = "failure";
            state.branches.add.error = action.payload;
        },
        cleanAddBranch: (state) => {
            state.branches.add.fetching = initialState.branches.add.fetching;
        },
        editBranchRequest: (state) => {
            state.branches.edit.fetching = "loading";
        },
        editBranchSuccess: (state, action) => {
            state.branches.edit.fetching = "success";
            state.branches.edit.data = action.payload;
        },
        editBranchFailure: (state, action) => {
            state.branches.edit.fetching = "failure";
            state.branches.edit.error = action.payload;
        },
        cleanEditBranch: (state) => {
            state.branches.edit.fetching = initialState.branches.edit.fetching;
        },
        deleteBranchRequest: (state) => {
            state.branches.delete.fetching = "loading";
        },
        deleteBranchSuccess: (state, action) => {
            state.branches.delete.fetching = "success";
            state.branches.delete.data = action.payload;
        },
        deleteBranchFailure: (state, action) => {
            state.branches.delete.fetching = "failure";
            state.branches.delete.error = action.payload;
        },
        cleanDeleteBranch: (state) => {
            state.branches.delete.fetching = initialState.branches.delete.fetching;
        },
        getDealershipsRequest: (state) => {
            state.dealerships.list.fetching = "loading";
        },
        getDealershipsSuccess: (state, action) => {
            state.dealerships.list.fetching = "success";
            state.dealerships.list.data = action.payload.dealerships;
            state.dealerships.list.total = action.payload.total;
        },
        getDealershipsFailure: (state, action) => {
            state.dealerships.list.fetching = "failure";
            state.dealerships.list.error = action.payload;
        },
        cleanGetDealerships: (state) => {
            state.dealerships.list.fetching = initialState.dealerships.list.fetching;
        },
        addDealershipRequest: (state) => {
            state.dealerships.add.fetching = "loading";
        },
        addDealershipSuccess: (state, action) => {
            state.dealerships.add.fetching = "success";
            state.dealerships.add.data = action.payload;
        },
        addDealershipFailure: (state, action) => {
            state.dealerships.add.fetching = "failure";
            state.dealerships.add.error = action.payload;
        },
        cleanAddDealership: (state) => {
            state.dealerships.add.fetching = initialState.dealerships.add.fetching;
        },
        editDealershipRequest: (state) => {
            state.dealerships.edit.fetching = "loading";
        },
        editDealershipSuccess: (state, action) => {
            state.dealerships.edit.fetching = "success";
            state.dealerships.edit.data = action.payload;
        },
        editDealershipFailure: (state, action) => {
            state.dealerships.edit.fetching = "failure";
            state.dealerships.edit.error = action.payload;
        },
        cleanEditDealership: (state) => {
            state.dealerships.edit.fetching = initialState.dealerships.edit.fetching;
        },
        deleteDealershipRequest: (state) => {
            state.dealerships.delete.fetching = "loading";
        },
        deleteDealershipSuccess: (state, action) => {
            state.dealerships.delete.fetching = "success";
            state.dealerships.delete.data = action.payload;
        },
        deleteDealershipFailure: (state, action) => {
            state.dealerships.delete.fetching = "failure";
            state.dealerships.delete.error = action.payload;
        },
        cleanDeleteDealership: (state) => {
            state.dealerships.delete.fetching = initialState.dealerships.delete.fetching;
        },
        getSellersTransferRequest: (state) => {
            state.transfer.sellers.fetching = "loading";
        },
        getSellersTransferSuccess: (state, action) => {
            state.transfer.sellers.fetching = "success";
            state.transfer.sellers.data = action.payload;
        },
        getSellersTransferFailure: (state) => {
            state.transfer.sellers.fetching = "failure";
        },
        cleanSellersTransfer: (state) => {
            state.transfer.sellers.fetching = initialState.transfer.sellers.fetching;
        },
        getSellersRequest: (state) => {
            state.sellers.fetching = "loading";
        },
        getSellersSuccess: (state, action) => {
            state.sellers.fetching = "success";
            state.sellers.data = action.payload;
        },
        getSellersFailure: (state, action) => {
            state.sellers.fetching = "failure";
            state.sellers.error = action.payload;
        },
        cleanSellers: (state) => {
            state.sellers.fetching = initialState.sellers.fetching;
        },
        addSellerRequest: (state) => {
            state.sellers.add.fetching = "loading";
        },
        addSellerSuccess: (state, action) => {
            state.sellers.add.fetching = "success";
            state.sellers.add.data = action.payload;
        },
        addSellerFailure: (state, action) => {
            state.sellers.add.fetching = "failure";
            state.sellers.add.error = action.payload;
        },
        cleanAddSeller: (state) => {
            state.sellers.add.fetching = initialState.sellers.add.fetching;
        },
        editSellerRequest: (state) => {
            state.sellers.edit.fetching = "loading";
        },
        editSellerSuccess: (state, action) => {
            state.sellers.edit.fetching = "success";
            state.sellers.edit.data = action.payload;
        },
        editSellerFailure: (state, action) => {
            state.sellers.edit.fetching = "failure";
            state.sellers.edit.error = action.payload;
        },
        cleanEditSeller: (state) => {
            state.sellers.edit.fetching = initialState.sellers.edit.fetching;
        },
        deleteSellerRequest: (state) => {
            state.sellers.delete.fetching = "loading";
        },
        deleteSellerSuccess: (state, action) => {
            state.sellers.delete.fetching = "success";
            state.sellers.delete.data = action.payload;
        },
        deleteSellerFailure: (state, action) => {
            state.sellers.delete.fetching = "failure";
            state.sellers.delete.error = action.payload;
        },
        cleanDeleteSeller: (state) => {
            state.sellers.delete.fetching = initialState.sellers.delete.fetching;
        },
        getStatusPublicationRequest: (state) => {
            state.status.fetching = "loading";
        },
        getStatusPublicationSuccess: (state, action) => {
            state.status.fetching = "success";
            state.status.data = action.payload;
        },
        getStatusPublicationFailure: (state) => {
            state.status.fetching = "failure";
        },
        cleanStatusPublication: (state) => {
            state.status.fetching = initialState.status.fetching;
        },
        setBranchDashboard: (state, action) => {
            state.dashboard.branch = action.payload;
        },
        setDateDashboard: (state, action) => {
            state.dashboard.date.start = action.payload.start;
            state.dashboard.date.end = action.payload.end;
        },
        getSalesPeriodRequest: (state) => {
            state.dashboard.salesPeriod.fetching = "loading";
        },
        getSalesPeriodSuccess: (state, action) => {
            state.dashboard.salesPeriod.fetching = "success";
            state.dashboard.salesPeriod.data = action.payload;
        },
        getSalesPeriodFailure: (state, action) => {
            state.dashboard.salesPeriod.fetching = "failure";
            state.dashboard.salesPeriod.error = action.payload;
        },
        cleanSalesPeriod: (state) => {
            state.dashboard.salesPeriod.fetching = initialState.dashboard.salesPeriod.fetching;
        },
        getSalesAcumulatedRequest: (state) => {
            state.dashboard.salesAcumulated.fetching = "loading";
        },
        getSalesAcumulatedSuccess: (state, action) => {
            state.dashboard.salesAcumulated.fetching = "success";
            state.dashboard.salesAcumulated.data = action.payload;
        },
        getSalesAcumulatedFailure: (state, action) => {
            state.dashboard.salesAcumulated.fetching = "failure";
            state.dashboard.salesAcumulated.error = action.payload;
        },
        cleanSalesAcumulated: (state) => {
            state.dashboard.salesAcumulated.fetching = initialState.dashboard.salesAcumulated.fetching;
        },
        getStatusPublicationsRequest: (state) => {
            state.dashboard.status.publications.fetching = "loading";
        },
        getStatusPublicationsSuccess: (state, action) => {
            state.dashboard.status.publications.fetching = "success";
            state.dashboard.status.publications.data = action.payload;
        },
        getStatusPublicationsFailure: (state, action) => {
            state.dashboard.status.publications.fetching = "failure";
            state.dashboard.status.publications.error = action.payload;
        },
        cleanStatusPublications: (state) => {
            state.dashboard.status.publications.fetching = initialState.dashboard.status.publications.fetching;
        },
        getStatusTransactionsRequest: (state) => {
            state.dashboard.status.transactions.fetching = "loading";
        },
        getStatusTransactionsSuccess: (state, action) => {
            state.dashboard.status.transactions.fetching = "success";
            state.dashboard.status.transactions.data = action.payload;
        },
        getStatusTransactionsFailure: (state, action) => {
            state.dashboard.status.transactions.fetching = "failure";
            state.dashboard.status.transactions.error = action.payload;
        },
        cleanStatusTransactions: (state) => {
            state.dashboard.status.transactions.fetching = initialState.dashboard.status.transactions.fetching;
        },
        getStatusChangesPublicationsRequest: (state) => {
            state.dashboard.statusChanges.publications.fetching = "loading";
        },
        getStatusChangesPublicationsSuccess: (state, action) => {
            state.dashboard.statusChanges.publications.fetching = "success";
            state.dashboard.statusChanges.publications.data = action.payload;
        },
        getStatusChangesPublicationsFailure: (state, action) => {
            state.dashboard.statusChanges.publications.fetching = "failure";
            state.dashboard.statusChanges.publications.error = action.payload;
        },
        cleanStatusChangesPublications: (state) => {
            state.dashboard.statusChanges.publications.fetching = initialState.dashboard.statusChanges.publications.fetching;
        },
        getStatusChangesTransactionsRequest: (state) => {
            state.dashboard.statusChanges.transactions.fetching = "loading";
        },
        getStatusChangesTransactionsSuccess: (state, action) => {
            state.dashboard.statusChanges.transactions.fetching = "success";
            state.dashboard.statusChanges.transactions.data = action.payload;
        },
        getStatusChangesTransactionsFailure: (state, action) => {
            state.dashboard.statusChanges.transactions.fetching = "failure";
            state.dashboard.statusChanges.transactions.error = action.payload;
        },
        getPublicationsReportRequest: (state) => {
            state.fetchingReport = "loading";
        },
        getPublicationsReportSuccess: (state, action) => {
            state.fetchingReport = "success";
            state.report = action.payload;
        },
        getPublicationsReportFailure: (state) => {
            state.fetchingReport = "failure";
        },
        cleanStatusChangesTransactions: (state) => {
            state.dashboard.statusChanges.transactions.fetching = initialState.dashboard.statusChanges.transactions.fetching;
        },
        getPublicationsSalesRequest: (state) => {
            state.dashboard.publicationsAndSales.fetching = "loading";
        },
        getPublicationsSalesSuccess: (state, action) => {
            state.dashboard.publicationsAndSales.fetching = "success";
            state.dashboard.publicationsAndSales.data = action.payload;
        },
        getPublicationsSalesFailure: (state, action) => {
            state.dashboard.publicationsAndSales.fetching = "failure";
            state.dashboard.publicationsAndSales.error = action.payload;
        },
        cleanPublicationsSales: (state) => {
            state.dashboard.publicationsAndSales.fetching = initialState.dashboard.publicationsAndSales.fetching;
        },
        getBranchRequest: (state) => {
            state.branch.fetching = initialState.branch.fetching;
        },
        getBranchSuccess: (state, action) => {
            state.branch.fetching = "success";
            state.branch.data = action.payload;
        },
        getBranchFailure: (state, action) => {
            state.branch.fetching = "failure";
            state.branch.error = action.payload;
        },
        cleanBranch: (state) => {
            state.branch.fetching = initialState.branch.fetching;
        },
        getMyOffersRequest: (state) => {
            state.myOffers.fetching = "loading";
        },
        getMyOffersSuccess: (state, action) => {
            state.myOffers.fetching = "success";
            state.myOffers.data = action.payload;
        },
        getMyOffersFailure: (state, action) => {
            state.myOffers.fetching = "failure";
            state.myOffers.error = action.payload;
        },
        cleanGetMyOffers: (state, action) => {
            state.myOffers.fetching = initialState.myOffers.fetching;
        },
    },
});

export const {
    getMyBuysRequest,
    getMyBuysSuccess,
    getMyBuysFailure,
    getMyPublicationsRequest,
    getMyPublicationsSuccess,
    getMyPublicationsFailure,
    cleanMyBuys,
    getMyBuyRequest,
    getMyBuySuccess,
    getMyBuyFailure,
    cleanMyBuy,
    cleanMyPublications,
    getRegionsRequest,
    getRegionsSuccess,
    getRegionsFailure,
    getCitiesRequest,
    getCitiesSuccess,
    getCitiesFailure,
    getPublicationsReportRequest,
    getPublicationsReportFailure,
    getPublicationsReportSuccess,
    getCommunesRequest,
    getCommunesSuccess,
    getCommunesFailure,
    getFavoritesRequest,
    getFavoritesSuccess,
    getFavoritesFailure,
    cleanFavorites,
    setFavorites,
    likePublicationRequest,
    likePublicationSuccess,
    likePublicationFailure,
    dislikePublicationRequest,
    dislikePublicationSuccess,
    dislikePublicationFailure,
    cleanLikePublication,
    setPublication,
    getCreditDataRequest,
    getCreditDataSuccess,
    getCreditDataFailure,
    getPaymentsRequest,
    getPaymentsSuccess,
    getPaymentsFailure,
    cleanPayments,
    postPaymentDocumentRequest,
    postPaymentDocumentSuccess,
    postPaymentDocumentFailure,
    postPaymentRequest,
    postPaymentSuccess,
    postPaymentFailure,
    cleanPayment,
    getSchedulesRequest,
    getSchedulesSuccess,
    getSchedulesFailure,
    cleanSchedules,
    putTransferPublicationRequest,
    putTransferPublicationSuccess,
    putTransferPublicationFailure,
    cleanTransferPublication,
    getBranchesTransferRequest,
    getBranchesTransferSuccess,
    getBranchesTransferFailure,
    cleanBranchesTransfer,
    getBranchesRequest,
    getBranchesSuccess,
    getBranchesFailure,
    cleanBranches,
    addBranchRequest,
    addBranchSuccess,
    addBranchFailure,
    cleanAddBranch,
    editBranchRequest,
    editBranchSuccess,
    editBranchFailure,
    cleanEditBranch,
    deleteBranchRequest,
    deleteBranchSuccess,
    deleteBranchFailure,
    cleanDeleteBranch,
    getDealershipsRequest,
    getDealershipsSuccess,
    getDealershipsFailure,
    cleanGetDealerships,
    addDealershipRequest,
    addDealershipSuccess,
    addDealershipFailure,
    cleanAddDealership,
    editDealershipRequest,
    editDealershipSuccess,
    editDealershipFailure,
    cleanEditDealership,
    deleteDealershipRequest,
    deleteDealershipSuccess,
    deleteDealershipFailure,
    cleanDeleteDealership,
    getSellersTransferRequest,
    getSellersTransferSuccess,
    getSellersTransferFailure,
    cleanSellersTransfer,
    getSellersRequest,
    getSellersSuccess,
    getSellersFailure,
    cleanSellers,
    addSellerRequest,
    addSellerSuccess,
    addSellerFailure,
    cleanAddSeller,
    editSellerRequest,
    editSellerSuccess,
    editSellerFailure,
    cleanEditSeller,
    deleteSellerRequest,
    deleteSellerSuccess,
    deleteSellerFailure,
    cleanDeleteSeller,
    getFilterMyPublicationsRequest,
    getFilterMyPublicationsSuccess,
    getFilterMyPublicationsFailure,
    cleanFilterMyPublications,
    cleanDataFiltersMyPublications,
    getStatusPublicationRequest,
    getStatusPublicationSuccess,
    getStatusPublicationFailure,
    cleanStatusPublication,
    setSearchMyPublications,
    setStatesMyPublications,
    setBranchesMyPublications,
    setYearsMyPublications,
    setSellersMyPublications,
    setBranchDashboard,
    setDateDashboard,
    getSalesPeriodRequest,
    getSalesPeriodSuccess,
    getSalesPeriodFailure,
    cleanSalesPeriod,
    getSalesAcumulatedRequest,
    getSalesAcumulatedSuccess,
    getSalesAcumulatedFailure,
    cleanSalesAcumulated,
    getStatusPublicationsRequest,
    getStatusPublicationsSuccess,
    getStatusPublicationsFailure,
    cleanStatusPublications,
    getStatusTransactionsRequest,
    getStatusTransactionsSuccess,
    getStatusTransactionsFailure,
    cleanStatusTransactions,
    getStatusChangesPublicationsRequest,
    getStatusChangesPublicationsSuccess,
    getStatusChangesPublicationsFailure,
    cleanStatusChangesPublications,
    getStatusChangesTransactionsRequest,
    getStatusChangesTransactionsSuccess,
    getStatusChangesTransactionsFailure,
    cleanStatusChangesTransactions,
    getPublicationsSalesRequest,
    getPublicationsSalesSuccess,
    getPublicationsSalesFailure,
    cleanPublicationsSales,
    getBranchRequest,
    getBranchSuccess,
    getBranchFailure,
    cleanBranch,
    getMyOffersRequest,
    getMyOffersSuccess,
    getMyOffersFailure,
    cleanGetMyOffers
} =
    profileSlice.actions;

export default profileSlice.reducer;
